import { type TextProps } from "../model";
import React, { CSSProperties } from "react";
import "./styles.scss";
import { type KC_Text_Sizes, type KC_Weights } from "../../ds_commons";

// KC_Text_Sizes.md == 14px
// KC_Text_Sizes.lg == 16px

interface KC_TextProps extends TextProps {
  size:
    | Extract<KC_Text_Sizes, KC_Text_Sizes.md | KC_Text_Sizes.lg>
    | "md"
    | "lg";
  weight:
    | Extract<KC_Weights, KC_Weights.bold | KC_Weights.reg>
    | "reg"
    | "bold";
  className?: string;
  style?: CSSProperties;
}

export default function KC_Text(props: KC_TextProps) {
  return (
    <span
      id={props.id}
      className={`kc-text kc-text-${props.weight}-${props.size} ${props.className ? props.className : ""}`}
      style={props.style}
    >
      {props.text}
    </span>
  );
}
